export const GET_TRANSACTIONREPORT_STATUS_LIST = "GET_TRANSACTIONREPORT_STATUS_LIST";
export const GET_TRANSACTIONREPORT_KEYWORD_LIST = "GET_TRANSACTIONREPORT_KEYWORD_LIST";

export const TRANSACTIONREPORT_LIST_ACTION = "TRANSACTIONREPORT_LIST_ACTION";
export const TRANSACTIONREPORT_WRITE_ACTION = "TRANSACTIONREPORT_WRITE_ACTION";
